module.exports = __webpack_public_path__ + "back.png?04b4d01b607fa43f045c44c815d07926";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/back.png
// module id = 930
// module chunks = 0